module.exports = __webpack_public_path__ + "img/text-block.f527de81.svg";